import { render, staticRenderFns } from "./VehiculosCompartidos.vue?vue&type=template&id=5fbb1ab1&scoped=true&"
import script from "./VehiculosCompartidos.vue?vue&type=script&lang=ts&"
export * from "./VehiculosCompartidos.vue?vue&type=script&lang=ts&"
import style0 from "./VehiculosCompartidos.vue?vue&type=style&index=0&id=5fbb1ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb1ab1",
  null
  
)

export default component.exports